import { Controller } from "@hotwired/stimulus"

// Swipe-to-delete on grocery rows. Inline editing is handled by Turbo Frames
// (tapping the item swaps the frame to grocery_items/edit), not here.
export default class extends Controller {
  static targets = ["content", "deleteAction"]
  static values = { deleteUrl: String }

  connect() {
    this.startX = 0
    this.currentX = 0
    this.swiping = false
  }

  touchstart(event) {
    this.startX = event.touches[0].clientX
    // Seed currentX so a plain tap (no touchmove) computes diff = 0 in
    // touchend instead of startX-px, which previously snapped the row
    // open as if the user had swiped the full screen width left.
    this.currentX = this.startX
    this.swiping = true
    this.contentTarget.style.transition = "none"
  }

  touchmove(event) {
    if (!this.swiping) return
    this.currentX = event.touches[0].clientX
    const diff = this.startX - this.currentX

    if (diff > 0) {
      const offset = Math.min(diff, 80)
      this.contentTarget.style.transform = `translateX(-${offset}px)`
      this.deleteActionTarget.style.opacity = Math.min(diff / 60, 1)
    }
  }

  touchend() {
    if (!this.swiping) return
    this.swiping = false
    const diff = this.startX - this.currentX
    this.contentTarget.style.transition = "transform 0.2s ease-out"

    if (diff > 60) {
      this.contentTarget.style.transform = "translateX(-80px)"
    } else {
      this.close()
    }
  }

  close() {
    this.contentTarget.style.transition = "transform 0.2s ease-out"
    this.contentTarget.style.transform = "translateX(0)"
    this.deleteActionTarget.style.opacity = "0"
  }
}
